export default function PlatformIntro() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <img
            src="https://readdy.ai/api/search-image?query=cozy%20reading%20atmosphere%20warm%20lighting%20comfortable%20armchair%20with%20tablet%20device%20soft%20cream%20and%20warm%20beige%20background%20minimalist%20interior%20relaxing%20mood%20gentle%20sunlight%20through%20window%20peaceful%20composition%20artistic%20illustration%20style&width=1200&height=400&seq=platform-intro-illustration&orientation=landscape"
            alt="韩漫网站阅读体验"
            className="w-full rounded-lg mb-8 md:mb-10 object-cover"
          />
          <p className="text-sm text-foreground-500 font-medium tracking-widest uppercase mb-4">关于韩漫网站</p>
          <p className="text-xl md:text-2xl lg:text-3xl font-heading text-foreground-900 leading-relaxed">
            我们相信每一部漫画都值得被看见。韩漫网站聚集了最优秀的韩漫作品，采用<strong>免费下拉式</strong>阅读体验，配合<strong>智能预加载</strong>技术，让你的阅读不受网络限制。无论你身在何处，<strong>韩漫在线观看</strong>都能带给你极致流畅的沉浸式体验。
          </p>
          <p className="text-sm text-foreground-400 mt-6">享受漫画，享受生活 ✨</p>
        </div>
      </div>
    </section>
  );
}